import { Component, OnInit } from '@angular/core';
import { AdminService } from '../service/admin.service';
import { AlertController, ModalController, Platform } from '@ionic/angular';
import { LoadingController, ToastController } from '@ionic/angular';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser'; //import temporal para asegurar url en desarrollo de registro de imagenes
import { ImageValidationService } from '../service/image-validation.service';
import { UsernameValidationService } from '../service/username-validation.service';
import { Constant } from '../shared/model/Constant';
import { AuthService } from '../service/auth.service';
import { PopoverController } from '@ionic/angular';
import { IntegrationService } from '../service/integration.service';
import { MapGeolocationComponent } from '../map-geolocation/map-geolocation.component';
import { PopoverContentComponent } from '../popover-content/popover-content.component';


@Component({
  selector: 'app-update-data-entities',
  templateUrl: './update-data-entities.page.html',
  styleUrls: ['./update-data-entities.page.scss'],
})
export class UpdateDataEntitiesPage implements OnInit {
  
  userInfo: any;
  isSuperUser = false;
  entities: any[] = [];
  showButtonsPage = false;
  showTable = true;
  showEdit = false;
  loading: any;
  userId: string = null;
  updatedBy: string = null;
  selectedEntity: any;
  userTypeEntityId: any;
  personTypeId: any;
  initialEntityData: any;
  countries: any[];
  departments: any[];
  cities: any[];
  cityId: any;
  departmentId: any;
  countryId: any;
  //Variables para el formulario de datos basicos
  editFields: any = {};
  phoneValid = true;
  phoneRepValid = true;
  cellPhoneRepValid = true;
  emailValid = true;
  emailRepValid = true;
  formValited = true;
  //INDICADORES SECCIONES ACTUALIZADAS
  updatedSocialNetworknShops: boolean = false;
  updatedImagesShops: boolean = false;
  updatedBasicData: boolean = false;
  areChangesBasicData = false;
  //VARIABLES ACTUALIZACION IMAGENES
  imagesCommerce: { file: File, url: SafeUrl, typePhoto: number, awsUrl: string, name: string }[] = [
    { file: null, url: null, typePhoto: null, awsUrl: null, name: null },
    { file: null, url: null, typePhoto: null, awsUrl: null, name: null },
    { file: null, url: null, typePhoto: null, awsUrl: null, name: null }
  ];
  //Variable para guardar las imagenes extraidas de base de datos
  currentImages: { file: File, url: SafeUrl, typePhoto: number, awsUrl: string, name: string, entityFileId: string }[] = [
    { file: null, url: null, typePhoto: null, awsUrl: null, name: null, entityFileId: null },
    { file: null, url: null, typePhoto: null, awsUrl: null, name: null, entityFileId: null },
    { file: null, url: null, typePhoto: null, awsUrl: null, name: null, entityFileId: null }
  ];     
  progress: number[] = [0, 0, 0];
  showProgress: boolean[] = [false, false, false];
  typePhotos: any[];
  //Variables para formulario redes sociales
  validRed: boolean = true;        //valida que todos las cuentas esten validas
  validationStatus: boolean[] = [true];  //valida que el nombre de la cuenta de cada red social este valido
  selectedCategory: number;
  socialNetworkn: any[] = [{}];
  socialNetworks: any;
  currentNetworkn: any[] = [{}];
  originalFilesToCrop: any[] = []; //arreglo para almacenar la imagen original cargada para poder restaurarla si esta ha pasado por el proceso de recorte
  //Mensajes para boton de I en imagenes
  popoverTitle: any = 'Al cargar la foto, ten en cuenta:';
  popoverMessage1: any = 'Aceptamos imágenes de hasta 5MB. Intenta que sean del tamaño de las fotos que tomas con tu teléfono.';
  popoverMessage2: any = 'También te recomendamos cargar imágenes rectangulares con medidas aproximadas de 1200x900 píxeles.';
  popoverMessage3: any = 'Aceptamos imágenes de hasta 5MB.  ';
  popoverMessage4: any = 'También te recomendamos cargar imágenes cuadradas. ';
  popover: any;
  //Variables para logo en Comercios En linea
  logoImage: any = null;
  fileType: any;
  originalLogo: any;
  //Variables para la tabla de seleccion entidad
  itemsPerPage = 10;
  currentPage = 1;
  filteredEntities: any[] = [];
  paginatedFilteredEntities: any[] = [];
  isMobile = false; //Variable para controlar el contenido responsive segun el tamaño de pantalla

  constructor(
    private adminService: AdminService,
    private authService: AuthService,
    private integrationService: IntegrationService,
    public alertController: AlertController,
    public toastController: ToastController,
    public loadingController: LoadingController,
    public modalController: ModalController,
    public popoverController: PopoverController,
    private imageValidationService: ImageValidationService,
    private sanitizer: DomSanitizer,
    private userValidationService: UsernameValidationService,
    private platform: Platform
  ) { }

  async ngOnInit() {
    this.loading = await this.loadingController.create({
      message: '',
      spinner: 'bubbles',
      duration: 5000
    });
    await this.loading.present();
    this.userId = localStorage.getItem(Constant.userId);
    this.updatedBy = this.userId;
    console.log(this.userId);
    await this.find();
    this.updatePagines();
    this.getTypePhotosShops();
    this.getSocialNetworks();
    this.getCountries();
    this.getDepartmentsCountries();
    this.getCitiesDepartments();
    await this.loading.dismiss();
    this.isMobile = !this.platform.is('desktop'); // Cambia según tus necesidades
  }

  async loadMap() {
    try {
      //Creo el modal y envio los datos
      const modal = await this.modalController.create({
        component: MapGeolocationComponent,
        componentProps: {
          address: this.selectedEntity?.address,
          latUser: parseFloat(this.selectedEntity?.latitude),
          lngUser: parseFloat(this.selectedEntity?.longitude),
          cityName: this.getCityNameById()
        }
      });
      //Muestro el modal con el mapa
      await modal.present();
      //Cuando el modal se cierra recibo los datos de geolocalizacion
      await modal.onWillDismiss().then((response: any) => {
        const data = response.data;
        if (data) {
          console.log('Resultado del proceso de actualización de geolocalización', data);
          this.selectedEntity.address = data.address;
          this.selectedEntity.latitude = data.latitude;
          this.selectedEntity.longitude = data.longitude;
          this.selectedEntity.plusCode = data.plusCode;
          console.log('La entidad despues de la geolocalizacion', this.selectedEntity);
          this.presentToast("Datos de la ubicación seleccionada obtenidos exitosamente");
        } else {
          this.presentToast("No se pudo realizar el proceso de geolocalización");
        }
      });
    } catch (error) {
      console.error("Error en el proceso de actualizacion de los datos geograficos", error);
    }
  }

  async presentToast(txt) {
    const toast = await this.toastController.create({
      message: txt,
      duration: 5000,
      position: 'top',
      mode: 'ios',
      color: 'primary'
    });
    toast.present();
  }

  //Metodo para cerrar el formulario de entidades y limpiar todos los campos relacionados
  async close() {
    this.updatedBasicData = false;
    this.updatedImagesShops = false;
    this.updatedSocialNetworknShops = false;
    this.loading = await this.loadingController.create({
      message: '',
      spinner: 'bubbles',
      duration: 3000
    });
    //Se vuelven a cargar los datos actualizados.
    await this.find();
    this.showTable = true;
    this.showEdit = false;
    this.areChangesBasicData = false;
    this.filteredEntities = this.entities;
    this.editFields = {};
    this.phoneValid = true;
    this.phoneRepValid = true;
    this.cellPhoneRepValid = true;
    this.emailValid = true;
    this.emailRepValid = true;
    this.updatePagines();
    //Se limpian validaciones y campos de redes sociales e imagenes
    this.selectedCategory = null;
    this.socialNetworkn = [{}];
    this.validationStatus = [true];
    this.originalLogo = null;
    this.originalFilesToCrop =[];
    this.currentNetworkn = [{}];
    this.imagesCommerce.forEach((image,i) => {      //Vacio el arreglo de imagenes nuevas dejando sus mismos 3 elementos
      image.file = null;
      image.url = null;
      image.typePhoto = null;
      image.awsUrl = null;
      image.name = null;
      this.progress[i] = 0;
      this.showProgress[i] = false;
    });
    this.currentImages.forEach(image => {      //Vacio el arreglo de imagenes actuales dejando sus mismos 3 elementos
      image.file = null;
      image.url = null;
      image.typePhoto = null;
      image.awsUrl = null;
      image.name = null;
    });
  }

  //Metodos get
  getTypePhotosShops() {
    this.adminService.getTypePhotos().subscribe((res: any[]) => {
      this.typePhotos = res;
    });
  }

  getSocialMediaUrl(id: any) {
    if (this.socialNetworks) {
      const socialNetwotk = this.socialNetworks.filter(i => i.socialNetworkId === id);
      if (socialNetwotk.length > 0) {
        const url = socialNetwotk[0].logoUrl;
        return url;
      }
    }
  }

  getSocialNetworks() {
    this.adminService.getSocialNetworks().subscribe((res: any) => {
      this.socialNetworks = res;
      console.log(this.socialNetworks)
    });
  }

  getCountries() {
    this.loading.present();
    this.adminService.getCountries().subscribe((res: any) => {
      this.countries = res;
      this.loading.dismiss();
    });
  }

  getDepartmentsCountries(countryId?) {
    this.loading.present();
    this.adminService.getDepartments(countryId).subscribe((res: any) => {
      this.departments = res;
      this.loading.dismiss();
    });
  }

  getCitiesDepartments(departmentId?) {
    this.loading.present();
    this.adminService.getCities(departmentId).subscribe((res: any) => {
      this.cities = res;
      this.loading.dismiss();
    });
  }

  getCityNameById() {
    const indexCity = this.cities.findIndex(city => city.cityId === this.cityId);
    const indexDpt = this.departments.findIndex(dept => dept.departmentId === this.departmentId);
   return this.cities[indexCity].name + ', ' + this.departments[indexDpt].name;      //variable con nombre de ciudad, departamento y pais para ubicar la ciudad sin margen de error
  }

  changeDepartment(event: any) {
    if (event && event.detail && event.detail.value) {
      this.getCitiesDepartments(event.detail.value);
    }
  }

  //Metodos para controlar la paginacion de la tabla 
  getPages(): number { return Math.ceil(this.filteredEntities.length / this.itemsPerPage); }

  onPageChange(pageNumber: number) {
    if (pageNumber >= 1 && pageNumber <= this.getPages()) {
      this.currentPage = pageNumber;
      this.updatePagines();
    }
  }

  updatePagines() {
    if (this.filteredEntities.length >= this.itemsPerPage) {
      this.showButtonsPage = true;
    } else {
      this.showButtonsPage = false;
    }
    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    const endIndex = startIndex + this.itemsPerPage;
    this.paginatedFilteredEntities = this.filteredEntities.slice(startIndex, endIndex);
  }

  filters(event) {        //filtro para cuadro de busqueda
    this.onPageChange(1);
    const searchTerm = event.target.value.trim().toLowerCase();

    if (!searchTerm) {
      this.filteredEntities = this.entities;
    } else {
      this.filteredEntities = this.entities.filter((entity) => {
        return (
          String(entity.companyId).toLowerCase().includes(searchTerm) ||
          String(entity.providerId).toLowerCase().includes(searchTerm) ||
          String(entity.distrutorId).toLowerCase().includes(searchTerm) ||
          String(entity.commerceId).toLowerCase().includes(searchTerm) ||
          entity.document.toLowerCase().includes(searchTerm) ||
          entity.firstName && entity.firstName.toLowerCase().includes(searchTerm) ||
          entity.secondName && entity.secondName.toLowerCase().includes(searchTerm) ||
          entity.firstLastName && entity.firstLastName.toLowerCase().includes(searchTerm) ||
          entity.secondSurName && entity.secondSurName.toLowerCase().includes(searchTerm)
        );
      });
    }
    this.updatePagines();
    if (this.filteredEntities.length === 0) {
      this.presentToast('No hay resultados');
    } 
  }

  //metodo identificar si hay cambios para realizar la actualizacion
  compareDataEntity(newDataEntity) {
    for (let value in newDataEntity) {
      if (newDataEntity[value] !== this.initialEntityData[value]) {
        this.areChangesBasicData = true;
        break;
      }
    }
  }

  //Metodo con validacion para desactivar los botones de actualizacion cuando una actualizacion se haya realizado
  disabledButtonChannels() {
    if (!this.validRed) {
      return true;
    }

    if ([2, 3, 4].includes(this.selectedEntity.entityTypeId)) {
      if (this.updatedSocialNetworknShops) {
        if (this.selectedEntity.entityTypeId === 4) {
            return this.updatedImagesShops; // Debe estar en true para desactivar el botón
        }
        return true;
      }
    } else {
      if (this.updatedBasicData) {
        return true
      }
    }
   
  }

  //Metodos con validaciones para campos del formulario
  validateOnlyText(fieldName: string, event: any) {
    if (this.editFields[fieldName]) {
      this.selectedEntity[fieldName] = event.target.value.replace(/[^a-zA-ZñÑ]/g, '');
    }
  }

  markFieldAsEdited(fieldName: string) {
    this.editFields[fieldName] = true;
  }

  validateField(fieldName: string, value: any) {
    if (this.editFields[fieldName]) {
      switch (fieldName) {
        case 'phone': {
          this.selectedEntity[fieldName] = value.replace(/\D/g, '').substring(0, 10);
          this.phoneValid = value.length >= 7;
          break;
        };
        case 'cellPhoneRep': {
          this.selectedEntity[fieldName] = value.replace(/\D/g, '').substring(0, 10);
          this.cellPhoneRepValid = value.length >= 7;
          break;
        };
        case 'phoneRep': {
          this.selectedEntity[fieldName] = value.replace(/\D/g, '').substring(0, 10);
          this.phoneRepValid = value.length >= 7;
          break;
        };
        case 'email': {
          this.emailValid = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(this.selectedEntity[fieldName]);
          break;
        };
        case 'emailRep': {
          this.emailRepValid = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(this.selectedEntity[fieldName]);
          break;
        };
        default: {
          break;
        }
      }
    }
  }

  async validateUsername(event, typeNetwork, index) {
    this.validationStatus[index] = true;
    this.socialNetworkn[index].account = await this.userValidationService.controlLength(event, typeNetwork);
    this.validationStatus[index] = await this.userValidationService.validateRedSocial(this.socialNetworkn[index].account, typeNetwork);
    this.validRed = this.isAllValid();
  }

  //Metodo para seleccionar una entidad y consultar su informacion relacionada para mostrar en formulario
  async EditEntities(entityData: any) {
    try {
      await this.loading.present();
      this.selectedEntity = { ...entityData };
      if (this.selectedEntity.entityTypeId === 4) {   //Cuando la entidad es comercio se debe mostrar la sección de imagenes
        this.authService.getCommerceId(this.selectedEntity.commerceId).subscribe((response: any) => {
          this.selectedCategory = response.businessCategoryId;    //Consulto si es categoria comercio en linea para mostrar logo
          console.log('El comercio tiene categoria Comercio En Linea?', this.selectedCategory === 5);
          if (this.selectedCategory === 5) {
            this.getShopLogo(this.selectedEntity.userId);
          } else {
            this.getShopImages(this.selectedEntity.entityId);
          }
        }, error => {
          console.log('Error en el proceso de extraccion de categoria de comercio',error);
          this.presentToast('No se pudo realizar la consulta de imagenes para la entidad, por favor recargue la pagina.')
        });
      }
      this.getEntitySocialNetworks(this.selectedEntity.overviewInformationId);    //Traigo las redes sociales
      this.showEdit = true;
      this.showTable = false;
      this.personTypeId = this.selectedEntity.personTypeId;
      this.initialEntityData = JSON.parse(JSON.stringify(entityData));
      console.log('se guardo la información de la entidad antes de realizar los cambios', this.initialEntityData);(entityData);
    } catch (error) {
      console.error('Error en la selección de entidad y la extraccion de sus datos relacionados:', error);
      this.presentToast(`Error en la selección de la entidad ${this.selectedEntity.entityId}`);
      this.close();
    } finally {
      await this.loading.dismiss()
    }
  }

  async saveEntitiesBasicData(data) {
      const alert = await this.alertController.create({
        header: 'Confirmar',
        message: '¿Está seguro de que desea guardar los cambios?',
        animated: true,
        buttons: [
          {
            text: 'Cancelar',
            role: 'cancel',
            cssClass: 'secondary',
            handler: (Cancel) => {
              console.log('Cancelando', this.socialNetworkn);
            }
          }, {
            text: 'Guardar',
            handler: () => {
              this.updateBasicData(data);
            }
          }
        ]
      });
      await alert.present();
  }
  async saveEntitiesSalesChannels() {
    const alert = await this.alertController.create({
      header: 'Confirmar',
      message: '¿Está seguro de que desea guardar los cambios?',
      animated: true,
      buttons: [
        {
          text: 'Cancelar',
          role: 'cancel',
          cssClass: 'secondary',
          handler: (Cancel) => {
            console.log('Cancelando');
          }
        }, {
          text: 'Guardar',
          handler: () => {
            this.updateSocialNetworks();
          }
        }
      ]
    });
    await alert.present();
  
  }
  async saveImagesCommerce() {
    const alert = await this.alertController.create({
      header: 'Confirmar',
      message: '¿Está seguro de que desea guardar los cambios?',
      animated: true,
      buttons: [
        {
          text: 'Cancelar',
          role: 'cancel',
          cssClass: 'secondary',
          handler: (Cancel) => {
            console.log('Cancelando');
          }
        }, {
          text: 'Guardar',
          handler: () => {
            this.selectedCategory !== 5 ? this.updateImages() : this.updateLogo();
          }
        }
      ]
    });
    await alert.present();
  
  }
  //Metodos para consultar las entidades disponibles y sus datos
  async find() {
    //Metodo que trae las entidades que pertenecen a la red del usuario activo y su informacion basica
    await this.loading.present();
    const userId = localStorage.getItem(Constant.userId);
    if (!userId) {
      console.error('User ID no disponible');
      this.presentToast('No hay un usuario activo');
      return;
    }

    try {
      const result: any = await this.adminService.getEntityInfo(userId).toPromise();
      this.userInfo = result;
      this.userTypeEntityId = this.userInfo.entityTypeId;
      console.log('El ID tipo de entidad del usuario actual es:', this.userTypeEntityId);

      if ([0,7].includes(this.userTypeEntityId)) {
        console.log('Se confirma que el usuario actual es administrador, se despliega lista de todas las entidades');
        this.isSuperUser = true;
      }

      if (this.isSuperUser) {
        await this.getAllEntities();     // si es super usuario trae todas las entidades
      } else {
        console.log('User ID para la búsqueda de entidades hijas', userId);
        const entitylist: any = await this.adminService.getEntitiesByUserId(userId).toPromise();    //si no es super usuario podra ver las entidades que estan por debajo de el en su red

        if (entitylist.length === 0) {
          this.presentToast('El usuario no tiene entidades dentro de su red para editar');
          this.showTable = false;
          setTimeout(() => {
            this.loading.dismiss();
            window.location.href = '/main';
            this.presentToast('Señor usuario, no dispone de usuarios en su red para realizar la actualización de datos básicos');
          }, 3500);
        } else {
          this.entities = entitylist;
          this.showTable = true;
        }
      }
      this.filteredEntities = this.entities;
      this.entities.forEach(element => {
        (element.entityTypeId !== 1) ? element.companyId = null : null;
      });
    } catch (error) {
      console.error('Error in find method:', error);
    }

  }

  async getAllEntities(): Promise<any[]> {        //si es super usuario podra ver todas las entidades
    try {
      await this.loading.present();

      if (!this.userId) {
        console.error('User ID no disponible');
        this.presentToast('No hay un usuario activo');
        return Promise.reject('User ID no disponible');
      }

      return new Promise<any[]>((resolve, reject) => {
        this.adminService.getAllEntities(this.userId).subscribe(
          (results: any) => {
            this.entities = results;
            this.showTable = true;
            resolve(results);
          },
          error => {
            this.presentToast('El usuario no tiene permisos para realizar esta acción');
            this.showTable = false;
            reject(error);
          },
          () => {
            this.loading.dismiss();
          }
        );
      });
    } catch (error) {
      console.error('Error en funcion getAllEntities:');
      return Promise.reject(error);
    }
  }

  async getEntitySocialNetworks(overviewInformationId) {      //Metodo para extraer las redes sociales de la entidad
    this.adminService.getNetworkInformation(overviewInformationId).subscribe((response: any[]) => {
      if (response.length > 0) {
        //realizo copias de los arreglos de esta forma para que los cambios hechos en uno no afecten al otro
      this.socialNetworkn = JSON.parse(JSON.stringify(response));
      this.currentNetworkn = JSON.parse(JSON.stringify(response));
      this.validationStatus = Array(response.length).fill(true);
      console.log('Las redes sociales extraidas que se mostraran: ', this.socialNetworkn);
      } else {
        console.warn(`La entidad ${this.selectedEntity.entityId} no registra redes sociales`);
      }
    }, (error) => {
      console.error('Error en el proceso de consulta de redes sociales', error);
      throw error
    });
  }

  //Las imagenes del comercio estan en un bucket de acceso privado, el backend debe extraer las imagenes de AWS como elementos tipo File
  async getShopImages(entityId) {
    try {
      this.adminService.getPhotosByEntity(entityId).subscribe((response: any[]) => {
        response.sort((a, b) => a.typeFileId - b.typeFileId); //Ordeno el arreglo segun el tipo de foto de forma ascendente 
        console.log('Url extraidas exitosamente:', response);
        //Valido si hay fotos para extraerlas
        if (response.length > 0) {
          
          let formData: any[] = [];
          response.forEach((url) => {
            const formObject = {
              urlS3: url.urlFile,
              entityId: entityId,
            }
            formData.push(formObject);
          });
          console.log('Extrayendo imagenes desde las url obtenidas desde AWS');
          this.integrationService.getImages(formData).subscribe((res: any[]) => {
            console.log('Imagenes extraidas de AWS', res);
            if (res.length > 0) {
              res.forEach((image, index) => {
                const typeFileId = response[index].typeFileId;
                const typePhoto = this.typePhotos.find(photo => photo.typeFileId === typeFileId);
                const base64 = this.base64ToFile(image.fileData, typePhoto.description, image.typeFile);
                let urlImage;
                if (Array.isArray(base64.name)) {
                  urlImage = this.imageValidationService.createObjectURL(base64.name[0]);
                } else {
                  urlImage = this.imageValidationService.createObjectURL(base64);
                }
                this.currentImages[index] = {
                  entityFileId: response[index].entityFileId,
                  typePhoto: response[index].typeFileId,
                  file: base64,
                  url: this.sanitizer.bypassSecurityTrustUrl(urlImage),
                  awsUrl: image.urlS3,
                  name: null//base64.name
                }
              });
              console.log('El arreglo de las imagenes  quedo asi: ', this.currentImages);
            } else {
              throw new Error('Error en la extracción de imagenes desde AWS');
            }
          });
          console.log('Se realizo el proceso de extracción de imagenes exitosamente');
        } else {
          //Si no registra imagenes informo por consola.
          console.warn(`La entidad ${entityId} no registra imagenes`);
        }
      });
     } catch(error){
        console.error('Error en la consulta de imagenes ', error);
        throw error
      };
  }

  //Teniendo en cuenta que el logo esta en un bucket de acceso publico se puede usar la url para convertir la foto a un elemento tipo File
  async getShopLogo(userId) {
    this.authService.getStyles(userId).subscribe(async (response: any) => {
      console.log('La informacion del logo:', response);
      //Obtener la imagen desde AWS y convertirla en un Blob
      const logoUrl = response[0].logo;
        this.logoImage = {
        file: null,
        url: logoUrl,//this.sanitizer.bypassSecurityTrustUrl(urlImage),
        name: null
      }
      this.originalLogo = logoUrl;
      console.log('Guarde', this.originalLogo, this.logoImage);
    }, error => {
      console.error('Error en la consulta de logo ', error);
      throw error
    });
  }

  //Metodos para el formulario de redes sociales
  async addSocialNeworks() {
    this.socialNetworkn.push({});
    this.validationStatus.push(true); // Añade una entrada de estado de validación correspondiente
    console.log('Asi quedo el arreglo de redes sociales', this.socialNetworkn);
  }

  async removeSocialNeworks() {
    if (this.socialNetworkn.length > this.currentNetworkn.length) {
      this.validationStatus.pop()
      this.socialNetworkn.pop();
      this.validRed = this.isAllValid();
    } else {
      console.warn("No esta permitido eliminar redes sociales");
    }    
  }

  isAllValid(): boolean {
    return Object.values(this.validationStatus).every(status => status);
  }

  //Metodos para recibir y procesar imagenes
  async onFileSelected(event: any, index: number) {
     //METODO QUE RECIBE 3 IMAGENES INGRESADAS POR EL USUARIO Y LAS VALIDA
    const inputElement = event.target.files[0];
    if (!inputElement) {
      console.warn('No se seleccionó un archivo');
      return;
    }
    event.target.value = '';
    this.originalFilesToCrop[index] = inputElement; //se almacena una copia de la imagen por si se desea recortar
    this.progress[index] = 0; // Reiniciar el contador de la barra
    this.showProgress[index] = true;
    this.showChargeIndicator(index);

    try {
      const isValidFile = await this.validateImage(inputElement); //validamos la extension y tamaño
      if (!isValidFile) {
        this.presentToast('La imagen seleccionada no cumple con los requisitos. Por favor, seleccione otra imagen e intente nuevamente.');
        this.clearFile(index);
        return;
      }
      const isAspectValid = await this.imageValidationService.validateAspect(inputElement);   //valida la relacion de aspecto
      let finalFile: File;
      let newUrl: string;
      if (!isAspectValid) {
        console.log('La relación de aspecto es incorrecta, ajustando...');
        const croppedBlob = await this.imageValidationService.cropImage(inputElement, 4 / 3); //si la relacion de aspecto no es valida la ajustamos usando canvas
        console.log('La imagen recortada CroppedBlob ', croppedBlob);
        const croppedFile = new File([croppedBlob], inputElement.name, { type: inputElement.type });
        console.log('El archivo generado para la imagen recortada CroppedFile', croppedFile);
        finalFile = croppedFile;
        console.log('Archivo Final Recortado:', finalFile);
        if (Array.isArray(finalFile.name)) {
          console.log('La propiedad name de la imagen es un array, por lo tanto de aqui tomo los datos de la imagen');
          newUrl = this.imageValidationService.createObjectURL(finalFile.name[0]);
        } else {
          console.log('La propiedad name de la imagen NO es un array, Se toma el objeto completo la imagen');
          newUrl = this.imageValidationService.createObjectURL(finalFile);
        }
        console.log('La url temporal creada para la imagen recortada: ', newUrl);
      } else {
        finalFile = inputElement;
        console.log('Archivo Final :', finalFile);
        newUrl = this.imageValidationService.createObjectURL(finalFile);  //creamos una nueva url temporal para evitar errores
        console.log('La url temporal creada: ', newUrl);
      }

      this.imagesCommerce[index] = {      //Creo un elemento del arreglo con los datos de la imagen cargada
        file: finalFile,
        url: this.sanitizer.bypassSecurityTrustUrl(newUrl),
        typePhoto: this.typePhotos[index].typeFileId,
        name: inputElement.name || null,
        awsUrl: null
      };

    } catch (error) {
      console.error('Error al procesar la imagen:', error);
      this.clearFile(index);
      console.warn('No se han cargado archivos');
    }
  }

  async cropImage(index: number) {
    if (this.imagesCommerce[index]?.file && this.originalFilesToCrop[index]) {      //se verifica que exista la imagen en el arreglo de imagenes de comercio e imagenes originales

      //se recorta la imagen original
      let newUrl;
      const file = this.originalFilesToCrop[index];
      console.log('el archivo original: ', file);
      const croppedBlob = await this.imageValidationService.cropImage(file, 4 / 3);
      console.log('La imagen recortada CroppedBlob ', croppedBlob);
      const croppedFile = new File([croppedBlob], file.name, { type: file.type });
      console.log('La imagen recortada: ', croppedFile);
      const finalFile = croppedFile;  //al parecer aca se encuentra el blob de la foto teniendo en cuenta que el objeto croppedFile es diferente en localhost que en los ambientes develop-prod
      if (Array.isArray(finalFile.name)) {
        console.log('La propiedad name de la imagen es un array, por lo tanto de aqui tomo los datos de la imagen');
        newUrl = this.imageValidationService.createObjectURL(finalFile.name[0]);
      } else {
        console.log('La propiedad name de la imagen NO es un array, Se toma el objeto completo la imagen');
        newUrl = this.imageValidationService.createObjectURL(finalFile);
      }
      this.imagesCommerce[index].url = this.sanitizer.bypassSecurityTrustUrl(newUrl);
      this.imagesCommerce[index].file = finalFile;
      console.log('el elemento del arreglo despues del recorte:', this.imagesCommerce[index]);
    } else {
      console.warn('No se encontro la imagen original para recortar.');
    }
  }

  async validateImage(file: File): Promise<boolean> {
    const validSize = this.imageValidationService.validateSizeFile(file);
    if (!validSize) {
      this.presentToast('El tamaño en MB de la imagen seleccionada es mayor al permitido. Por favor, seleccione una imagen más pequeña.');
      return false;
    }
    const validExtension = this.imageValidationService.validateExtension(file);
    if (!validExtension) {
      this.presentToast('El tipo de archivo seleccionado no es una imagen. Por favor, seleccione otro archivo');
      return false;
    }
    return true;
  }

  async showChargeIndicator(index: number) {
    return new Promise<void>((resolve) => {
      const incrementInterval = setInterval(() => {
        this.progress[index] += 0.035;
        if (this.progress[index] >= 1) {
          clearInterval(incrementInterval); // Detener el incremento cuando alcanza 100%
          resolve(); // Resuelve la promesa cuando el progreso llega al 100%
        }
      }, 100);
    });
  }

  uploadLogos(event: any) {
    this.loading.present();
    if (event.target.files[0]) {
      const inputElement = event.target.files[0];
      const entityId = this.selectedEntity.entityId;
      this.fileType = inputElement.type;
      console.log('Archivo Cargado: ', inputElement);
      this.progress[0] = 0; // Reiniciar el contador de la barra
      this.showProgress[0] = true;
      this.showChargeIndicator(0);
      // Corregir la relación de aspecto
      this.imageValidationService.correctAspectRatio(inputElement, 1 / 1).then(async ({ blob, width, height }) => {
        const finalFileLogo = new File([blob], inputElement.name, { type: inputElement.type });

        // Mostrar las dimensiones de la imagen ajustada
        console.log('Dimensiones de la imagen ajustada', width, 'y', height, 'y el IdEntity', entityId);

        // Crear URL temporal para la previsualización de la imagen ajustada
        let newUrl;
        if (Array.isArray(finalFileLogo.name)) {
          console.log('La propiedad name de la imagen es un array, por lo tanto de aqui tomo los datos de la imagen para el backend');
          newUrl = this.imageValidationService.createObjectURL(finalFileLogo.name[0]);
        } else {
          console.log('La propiedad name de la imagen NO es un array, Se toma el objeto completo la imagen para el backend');
          newUrl = this.imageValidationService.createObjectURL(finalFileLogo);
        }
        console.log('URL temporal creada:', newUrl);

        // Asignar la imagen a la propiedad que maneja la previsualización (logoImage)
        this.logoImage = {
          file: finalFileLogo,
          url: this.sanitizer.bypassSecurityTrustUrl(newUrl),
          name: inputElement.name
        };

        // Mostrar la imagen en la interfaz
        console.log('logoImage asignado correctamente:', this.logoImage);
        
        this.loading.dismiss(); // Finaliza el loading después de completar el proceso

      }).catch(error => {
        console.log('Error al corregir la imagen:', error);
        this.clearFile(0);  // Limpia el archivo en caso de error
        this.loading.dismiss();
      });
    }
  }

  clearFile(index: number) {
    if (this.selectedCategory === 5) {
      // Limpia la imagen única (logo)
      this.logoImage = null;
      this.progress[0] = 0;
      this.showProgress[0] = false;
      this.originalFilesToCrop[0] = null;

      // Reinicia el input de archivo
      const inputElement = document.getElementById('logoInput') as HTMLInputElement;
      if (inputElement) {
        inputElement.value = ''; // Limpiar el valor del input
      }
    } else {
      this.imagesCommerce[index] = {      //Vacio el arreglo de imagenes nuevas dejando sus mismos 3 elementos
        file: null,
        url: null,
        typePhoto: null,
        awsUrl: null,
        name: null
      }
      this.progress[index] = 0;
      this.showProgress[index] = false;
      this.originalFilesToCrop[index] = null;
    }
  }

  //Metodo para convertir una imagen en base 64 en un objeto tipo File
  base64ToFile(base64Data: string, fileName: string, fileType: string): File {
    const byteString = atob(base64Data);  // Decodificar la cadena Base64
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const intArray = new Uint8Array(arrayBuffer);

    // Asignar los bytes al array
    for (let i = 0; i < byteString.length; i++) {
      intArray[i] = byteString.charCodeAt(i);
    }

    const blob = new Blob([intArray], { type: fileType });  // Crear un Blob
    return new File([blob], fileName, { type: fileType });  // Convertir el Blob en un objeto File
  }

   //Metodos para realizar la edición de los datos
   async updateBasicData(data) {     //metodo que realiza la actualizacion de la entidad
    try {
      await this.loading.present();
      this.compareDataEntity(data);   //compara los datos ingresados en el formulario con los que tiene actualmente con el fin de confirmar si hay cambios
      if (this.areChangesBasicData) {
        data.updatedBy = this.userId;
        console.log('Información recibida para ser editada', data);
        this.adminService.updateEntities(data).subscribe(response => {
          console.log(response);
          const name = this.selectedEntity.tradeName || `${this.selectedEntity.firstName} ${this.selectedEntity.firstLastName}`
          this.presentToast(`Se actualizo la información básica para ${name} exitosamente.`);
          this.updatedBasicData = true;
          
          if (this.updatedBasicData && this.disabledButtonChannels()) {
            alert(`Se ha completado la actualización de datos para la entidad ${name}`);
            this.close();
          }
        });
      } else {
        this.presentToast('No se han ingresado nuevos datos básicos para actualizar');
      }
    } catch (error) {
      console.error('Error en el proceso de actualización de entidad: ', error);
      this.presentToast('Error en la actualización de datos básicos. Por favor intente nuevamente');
    } finally {
      this.loading.dismiss();
    }
  }

  async updateSocialNetworks() {
    try {
      if (this.updatedSocialNetworknShops) return
      const name = this.selectedEntity.tradeName || `${this.selectedEntity.firstName} ${this.selectedEntity.firstLastName}`
      const overviewId = this.selectedEntity.overviewInformationId;
      let updatedNetworks = [];
      
      this.socialNetworkn.forEach(socialNetwork => {
        const currentNetwork = this.currentNetworkn.find(network => network.networkInformationId === socialNetwork.networkInformationId);
        if (!currentNetwork || socialNetwork.account !== currentNetwork.account) {
          const newDataNetwork = {
            networkInformationId: currentNetwork?.networkInformationId || null,
            overviewInformationId: overviewId,
            account: socialNetwork.account,      //Envio la nueva cuenta
            socialNetworkId: socialNetwork.socialNetworkId,
            updatedBy: this.updatedBy 
          }
          updatedNetworks.push(newDataNetwork);
        }
      });
      
      //Si la pagina web ha sido modificada la variable sera true
      const isWebPageChanged = this.selectedEntity.webPage !== this.initialEntityData.webPage
      //Valido si hay redes para actualizar o agregar
      if (!isWebPageChanged && updatedNetworks.length < 1) {
        console.warn("No hay pagina web o redes sociales modificadas para actualizar");
        this.presentToast("Señor usuario, no hay canales de venta modificados o agregados para el proceso de actualización");
        return
      }
      //Valido que datos se cambiaron para actualizarlos
      if (isWebPageChanged) {
        console.log("Actualizando pagina web");
        const data = {
          webPage: this.selectedEntity.webPage,
          updatedBy: this.userId,
          overviewInformationId: overviewId,
          entityId: this.selectedEntity.entityId
        }
        this.adminService.updateEntities(data).subscribe(response => {
          console.log("Actualización de pagina web completa"); 
          this.presentToast("Canales de venta actualizados exitosamente");
        });
      } else {
        console.warn("La pagina web no se ha modificado");
      }

      if (updatedNetworks.length > 0) {
        //Teniendo en cuenta que las redes sociales se validan a medida que se digitan valores en el campo
        //envio a la funcion de validacion la ultima red social en el arreglo para evitar enviarse al backend
        // en caso de que se haya agregado y no se haya llenado el campo ya que al agregarse el estado de validacion es true
        const lastIndex = this.socialNetworkn[this.socialNetworkn.length - 1];
        await this.validateUsername(lastIndex.account, lastIndex.socialNetworkId, this.socialNetworkn.length - 1);
        if (!this.validRed) {     //Reviso el metodo de validacion de redes
          console.warn('No se han completado correctamente las redes sociales');
          return
        }
        console.log('Actualizare las redes sociales: ', updatedNetworks);
        this.adminService.updateSocialNetworks(updatedNetworks).subscribe(res => {
          console.log(res);
        });
      }
      this.updatedSocialNetworknShops = true;
      if (this.updatedBasicData && this.updatedImagesShops) this.close();
      this.presentToast(`Se actualizaron los canales de venta para ${name} exitosamente`);
    } catch(error) {
      console.error('Error al actualizar redes sociales', error);
      this.updatedSocialNetworknShops = false;
      this.presentToast(`Error en el proceso de actualización de canales de venta`);
    };
  }

  async updateImages() {
    try {
      if (this.updatedImagesShops) return
      const name = this.selectedEntity.tradeName || `${this.selectedEntity.firstName} ${this.selectedEntity.firstLastName}`
      console.log('Estas son las imagenes que debo guardar: ', this.imagesCommerce);
      const hasFiles = this.imagesCommerce.some(element => element && element.file !== null);   //primero verificamos si han cargado imagenes antes de realizar el proceso.
      if (hasFiles) {       //Sí hay fotos hacemos el proceso de registro de imagenes
        const filesToSave = [];
        const idPhoto = [];   //aca relacionare cada tipo de foto con su foto
        this.imagesCommerce.forEach((element, index) => {
          if (element){
            if (element.file !== null) {
              filesToSave.push(element.file);
              idPhoto.push(this.typePhotos[index].description);  //aca guardare el nombre de cada foto para enviarlo al registro, debe ir en un arreglo diferente a las fotos para evitar errores
            }
          }
        });
        console.log('Tipos de fotos a enviar ', idPhoto);
        this.integrationService.registerImageShops(filesToSave, idPhoto, this.selectedEntity.entityId).subscribe((results: any[]) => {
          console.log('imagenes registradas en Bucket', results);
          // Verifica que la variable que almacenara el request se haya cargado correctamente
          if (results.length < 1) {    
            throw new Error('Error al crear el request para metodo de registro de fotos para entidad');
          }
          let urlDatabaseArray = [];
          // Se retorna el nombre con el que cada archivo queda en AWS para mostrarlo junto la imagen
          results.forEach((result, index) => {
            const typePhoto = this.typePhotos.find(photo => photo.description === idPhoto[index]);
            console.log('Registrare en base el tipo de imagen', typePhoto);
            //Asigno el nombre con el que se guardo la imagen para que se actualice en pantalla
            const imageCommerce = this.imagesCommerce.find(photo => photo.typePhoto === typePhoto.typeFileId);
            console.log('La imagen donde aplicare el cambio de nombre', imageCommerce);
            imageCommerce.name = result.fileName;
            //Creo un objeto con los datos que registrare en base de datos
            const originalDataImage = this.currentImages.find(photo => photo.typePhoto === typePhoto.typeFileId);
            console.log('encontre en el filtrado', originalDataImage);
            const urlDatabaseObject = {
              entityFileId: originalDataImage?.entityFileId || null,
              entityId: this.selectedEntity.entityId,
              typeFileId: typePhoto.typeFileId,
              urlFile: result.urlS3,
              updatedBy: this.updatedBy,
            }
            urlDatabaseArray.push(urlDatabaseObject);
          });
          console.log('datos recibidos desde S3 para guardar en base: ', urlDatabaseArray);
          //Actualizo la url en base de datos con las nuevas imagenes 
          this.adminService.updatePhotoForEntity(urlDatabaseArray).subscribe(response => {
            if (response) {
              console.log('se registraron las imagenes exitosamente ', response);
              this.updatedImagesShops = true;
              this.presentToast(`Se actualizaron las imagenes para el comecio ${name} exitosamente`);
              if (this.updatedBasicData && this.updatedSocialNetworknShops) this.close();
            }
          });
        });
      } else {
        console.warn('No se han cargado imagenes para registrar');
        this.presentToast("Señor usuario, no se han agregado imagenes para el proceso de actualización");
      }
    } catch (error) {
      console.error('Error en proceso de registro de las imagenes en AWS ', error);
      this.presentToast(`Error en el proceso de actualización de imagenes`);
      this.updatedImagesShops = false;
    }
  }

  async updateLogo() {
    if (this.updatedImagesShops) return
    if (this.originalLogo === this.logoImage.url) {
      console.warn('Son iguales');
      return
    }
    const name = this.selectedEntity.tradeName || `${this.selectedEntity.firstName} ${this.selectedEntity.firstLastName}`;
    this.adminService.uploadFileLogo(this.logoImage.file, 'logos', this.selectedEntity.entityId).subscribe((res: any) => {
      if (!res) {
        throw new Error('Error actualizando el logo en AWS');
      }
      this.logoImage.url = res.urlS3;
      this.logoImage.name = res.fileName;
      const formData = { 
        logo: this.logoImage.url, 
        userId: this.selectedEntity.userId,
        updatedBy: this.userId
      }
      this.authService.updateStyle(this.selectedEntity.userId, formData).subscribe(res => {
        this.updatedImagesShops = true
        this.presentToast(`Se actualizaron las imagenes para el comecio ${name} exitosamente`);
        if (this.updatedBasicData && this.updatedSocialNetworknShops) this.close();
      });
    }, error => {
      console.log('Error en el proceso de actualizacion de logo', error);
      this.presentToast(`Error en el proceso de actualización de imagenes`);
    });
  }

  async presentPopover(ev: Event) {
    if (this.popover) {
      await this.dismissPopover();
    } else {
      const popover = await this.popoverController.create({
        component: PopoverContentComponent,
        componentProps: {
          title: this.popoverTitle,
          message: this.selectedCategory !== 5 ? this.popoverMessage1 : this.popoverMessage3,
          message2: this.selectedCategory !== 5 ? this.popoverMessage2 : this.popoverMessage4,
        },
        event: ev,
        showBackdrop: false,
        backdropDismiss: true,
        mode: 'ios',
        animated: true
      });

      this.popover = popover;

      // Listener para clics dentro del popover y en el ícono
      this.popover.onDidDismiss().then(() => {
        this.popover = null;
      });

      await popover.present();
    }
  }


  async dismissPopover() {
    if (this.popover) {
      await this.popover.dismiss();
      this.popover = null;
    }
  }
}

